export function isPingMessage(candidate) {
    return (candidate !== null &&
        typeof candidate === "object" &&
        "displayDuration" in candidate &&
        "type" in candidate);
}
